import { inject, observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "src/components";
import { Item, Tag } from "src/models";
import { CardContainer } from "src/pages";
import { EmptyCard, TagCard } from "src/pages/settings/cards";
import { TagStore } from "src/stores";
import { IItem } from "src/types";
import styled from "styled-components";

export interface ITagViewProps {
  item: Item<IItem> ,
  tagStore?: TagStore;
}

export const TagView = inject("tagStore")(observer((props: ITagViewProps): JSX.Element => {
  const { item, tagStore } = props;
  const { t, i18n } = useTranslation();

  const curTags:    Tag[] = tagStore.getActiveItemTags;
  const tagOptions: Tag[] = tagStore.getTagOptions;

  return (
    <Container>
      <CardContainer>
        {curTags.length ? 
          curTags.map(t => <TagCard key={t.id} data={t} onClick={() => tagStore.unlinkTag(t.id)}/>)
          : <EmptyCard disableHover icon={<Text fontStyle="italic">{t("no_tag_selected")}</Text>}/>
        }
      </CardContainer>
      <Divider><hr/></Divider>
      <CardContainer>
        {tagOptions.map(t => <TagCard key={t.id} data={t} onClick={() => tagStore.linkTag(t.id)}/>)}
      </CardContainer>
    </Container>
  );
}));

const Container = styled.div`
  display:        flex;
  flex-direction: column;
  >* {
    margin-bottom: 1rem;
  }
`;

const Divider = styled.div`
  margin-top: 2rem;
`;